module.exports = __webpack_public_path__ + "img/helmet-battle.3912d22b.svg";